import styled from 'styled-components';

interface ISlide {
  show: boolean;
  startAnim: boolean;
  notShow?: boolean;
}

export const Container = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  opacity: ${(props) => (props.show ? 1 : 0)};
  background-color: #f1e8df;
  min-width: 980px;
  min-height: 551.25px;
`;

export const Slide1 = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};

  .slide-container {
    width: 980px;
    height: 551.25px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 1;

    .lotus {
      position: absolute;
      left: 0;
      top: 0;
      width: 362px;
      height: 272px;
      transition-duration: 0.3s;
    }

    .botox {
      position: absolute;
      right: 0;
      top: 0;
      width: 371px;
      height: 551px;
      transition-duration: 0.3s;
    }

    .woman {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 540.26px;
      height: 551px;
      transition-duration: 0.3s;
    }

    h2 {
      font-size: 70px;
      font-family: 'poppins';
      width: 210px;
      position: absolute;
      left: 57.4px;
      top: 196.42px;
      color: #442300;
      display: grid;
    }

    .content {
      position: absolute;
      left: 57.4px;
      top: 383.05px;
      width: 281.06px;
      height: 122.16px;
      transition-duration: 0.3s;

      p {
        margin-bottom: 0;
        font-size: 24px;
        font-family: 'poppins';
        color: #000;
      }

      .brown {
        margin-bottom: 0;
        font-size: 34px;
        font-weight: 500;
        font-family: 'poppins';
        color: #bf3e17;
      }
    }

    .date {
      position: absolute;
      left: 729.56px;
      top: 432.36px;
      width: 220.58px;
      height: 62.7px;
      transition-duration: 0.3s;
      background-color: #c67329;
      font-size: 30px;
      font-family: 'poppins';
      color: #fff;
      margin-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50px;
    }
  }
`;

export const Slide2 = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};

  .slide-container {
    width: 980px;
    height: 551.25px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 1;

    .botox {
      position: absolute;
      right: 0;
      top: 0;
      width: 371px;
      height: 551px;
      transition-duration: 0.3s;
    }

    h2 {
      font-size: 45px;
      font-family: 'poppins';
      width: 381.43px;
      position: absolute;
      left: 79.99px;
      top: 76.88px;
      color: #351c00;
    }

    .content {
      position: absolute;
      left: 79.99px;
      top: 200px;
      width: 254px;
      transition-duration: 0.3s;
      font-size: 24px;
      font-family: 'poppins';
      color: #000;
    }

    .beforeAfter1 {
      position: absolute;
      left: 79.99px;
      top: 263.88px;
      width: 405.46px;
      height: 222.55px;
      transition-duration: 0.3s;
    }

    .beforeAfter2 {
      position: absolute;
      left: 497.4px;
      top: 266.04px;
      width: 418.28px;
      height: 220.39px;
      transition-duration: 0.3s;
    }

    .models {
      position: absolute;
      left: 507.59px;
      top: 96.18px;
      width: 452.34px;
      height: 62.7px;
      transition-duration: 0.3s;
      background-color: #bf8851;
      border: 1px solid #ddc0a4;
      font-size: 24px;
      font-family: 'poppins';
      color: #000;
      margin-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50px;
    }
  }
`;
